<!-- TODO Has to be refactored in order to use ng-templates for readability -->
<app-modal [dismissible]="false"
           class="popup-confirmation"
           [isLoading]="isConfirmationInProgress">
    <div class="modal-header"
         modal-header>
        <h5 class="modal-title">{{ title }}</h5>
    </div>
    <div class="modal-body"
         *ngIf="!isError && !confirmWithReason && !displayReasonMode"
         [class.compact]="isCustomContent || confirmOnlyMode"
         modal-body>
        <p class="message" *ngIf="question">{{ question }}</p>
        <p *ngIf="!isError" style="white-space: pre;">{{ message }}</p>
        <app-badge-scanner *ngIf="!confirmWithReason && !displayReasonMode && !confirmOnlyMode && this.modal.isOpen()"
                           (scan)="onScan($event)"
                           (error)="onInvalidBadge($event)"
        ></app-badge-scanner>
    </div>
    <div class="modal-body compact error-body" *ngIf="isError" modal-body>
        <app-alert
            type="error"
            [responsive]="true"
            [message]="message"></app-alert>
    </div>
    <div class="modal-body" *ngIf="confirmWithReason || displayReasonMode" modal-body>
        <app-textarea [formControl]="formGroup.controls['reason']"
                      [showErrors]="showErrors"
                      [label]="displayReasonLabel"
                      [placeholder]="displayReasonPlaceholder">
        </app-textarea>
    </div>
    <div class="modal-body" *ngIf="isCustomContent" modal-body>
        <ng-content select="[modal-custom-content]"></ng-content>
    </div>
    <div class="modal-footer" modal-footer>
        <app-button type="simple"
                    (clicked)="onCancel()"
                    [disabled]="isConfirmationInProgress"
                    data-dismiss="modal">{{ "generic.buttons.close" | translate }}
        </app-button>
        <div class="mutators">
            <app-button *ngIf="confirmWithReason || displayReasonMode"
                        type="primary"
                        (clicked)="onConfirmReason()"
                        [disabled]="isConfirmationInProgress">{{ "generic.buttons.confirm" | translate }}
            </app-button>
            <app-button *ngIf="confirmOnlyMode && showConfirmButton"
                        type="primary"
                        [disabled]="confirmButtonDisabled || isConfirmationInProgress"
                        (clicked)="onConfirmEvent()">{{ "generic.buttons.confirm" | translate }}
            </app-button>
        </div>
    </div>
</app-modal>
